export function applyChatRailInert(
	element: HTMLElement | null,
	isOpen: boolean,
): void {
	if (!element) return
	if (isOpen) {
		element.removeAttribute("inert")
		return
	}
	element.setAttribute("inert", "")
}
